export var GeneralData;
(function (GeneralData) {
    GeneralData.Months = [
        { label: '01', value: 'January', days: 31 },
        { label: '02', value: 'February', days: 28 },
        { label: '03', value: 'March', days: 31 },
        { label: '04', value: 'April', days: 30 },
        { label: '05', value: 'May', days: 31 },
        { label: '06', value: 'June', days: 30 },
        { label: '07', value: 'July', days: 31 },
        { label: '08', value: 'August', days: 31 },
        { label: '09', value: 'September', days: 30 },
        { label: '10', value: 'October', days: 31 },
        { label: '11', value: 'November', days: 30 },
        { label: '12', value: 'December', days: 31 },
    ];
})(GeneralData || (GeneralData = {}));
